import state from "./device.state";
import actions from "./device.actions";
import mutations from "./device.mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
